export const SET_IS_LOADING = 'SELF_SERVICE/SET_IS_LOADING';
export const SET_SELF_SERVICE_USERS = 'SELF_SERVICE/SET_SELF_SERVICE_USERS';
export const CLEAR_SELF_SERVICE_USERS = 'SELF_SERVICE/CLEAR_SELF_SERVICE_USERS';
export const SET_IS_SETTINGS_LOADING = 'SELF_SERVICE/SET_IS_SETTINGS_LOADING';
export const SET_SELF_SERVICE_SETTINGS = 'SELF_SERVICE/SET_SELF_SERVICE_SETTINGS';
export const CLEAR_SELF_SERVICE_SETTINGS = 'SELF_SERVICE/CLEAR_SELF_SERVICE_SETTINGS';